import { CheckOutlined, ExpandOutlined, TeamOutlined } from "@ant-design/icons"
import { Button, Flex, Tooltip, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface NotificationsPopoverHeaderProps {
  unreadCount: number
  onMarkAllAsRead: () => void
  onExpand: () => void
  disabled?: boolean
  isCustomerActivityOnly: boolean
  onToggleCustomerActivityOnly: () => void
}

export function NotificationsPopoverHeader({
  unreadCount,
  onMarkAllAsRead,
  onExpand,
  disabled = false,
  isCustomerActivityOnly,
  onToggleCustomerActivityOnly
}: NotificationsPopoverHeaderProps) {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={4}>
      <Flex justify="space-between" align="center">
        <Text strong>
          {t("notifications.bell.title", { n: unreadCount })}
        </Text>
        <Flex gap={8} align="center">
          {disabled && (
            <Text type="secondary" className="text-xs">
              {t("notifications.bell.offline")}
            </Text>
          )}
          {unreadCount > 0 && (
            <Button
              type="link"
              size="small"
              icon={<CheckOutlined />}
              className="p-0 h-auto text-xs"
              onClick={onMarkAllAsRead}
              disabled={disabled}
            >
              {t("notifications.bell.markAllRead")}
            </Button>
          )}
          <Button
            type="text"
            size="small"
            icon={<ExpandOutlined aria-hidden />}
            className="p-0 h-auto text-xs"
            onClick={onExpand}
          >
            {t("notifications.bell.viewAll")}
          </Button>
        </Flex>
      </Flex>
      <Tooltip title={t("notifications.bell.customerActivityFilterHint")}>
        <Button
          type={isCustomerActivityOnly ? "primary" : "default"}
          size="small"
          icon={<TeamOutlined aria-hidden />}
          className="self-start !text-xs"
          aria-pressed={isCustomerActivityOnly}
          onClick={onToggleCustomerActivityOnly}
        >
          {t("notifications.bell.customerActivityFilter")}
        </Button>
      </Tooltip>
    </Flex>
  )
}
